import { MouseEventHandler } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { InitialCausalityListActionsProps } from './props';
import { INITIAL_CAUSALITY_EDIT } from '../../../../../../routes/paths';

export const InitialCausalityListActions = ({
    id,
}: InitialCausalityListActionsProps) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${INITIAL_CAUSALITY_EDIT}/${id}`, '_blank');
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
